<template>
  <div class="cart-page__body">
    <div class="cart-page__content">
      <div class="cart-page__products cart-products">
        <div class="cart-products__items">
          <div
            v-for="item in $cart.items" :key="'cart_item'+item.id"
            class="cart-products__item">
            <div class="cart-product-item">
              <div class="cart-product-item__icon">
                <img
                  :src="baseUrl+item.thumbnail"
                  :alt="item.name" class="cart-product-item__img" />
              </div>
              <div class="cart-product-item__content">
                <div class="cart-product-item__main-info">
                  <div class="cart-product-item__name">
                    <a
                      :href="item.get_absolute_url"
                      target="_blank"
                      class="cart-product-item__link">{{ item.name }}</a>
                  </div>
                  <ul class="cart-product-item__labels">
                    <li
                      v-if="item.sale_percent"
                      class="cart-product-item__label product-label product-label--sale">
                      <span class="product-label__text product-label__text--sale">-{{ item.sale_percent.toFixed(0) }}%</span>
                    </li>
                    <li
                      v-if="item.is_popular"
                      class="cart-product-item__label product-label">
                      <i class="fa fa-fire product-label__icon"></i>
                      <span class="product-label__text">Хит!</span>
                    </li>
                  </ul>
                </div>

                <div class="cart-product-item__price-area">
                  <div class="cart-product-item__price">{{ formatNumberWithSpaces(item.total_price.toFixed(0)) }} руб.</div>
                  <div
                    v-if="item.profit"
                    class="cart-product-item__price-raw">{{ formatNumberWithSpaces(item.raw_total_price.toFixed(0)) }} руб.</div>
                </div>

                <div class="cart-product-item__actions">
                  <div class="cart-actions">
                    <div class="cart-actions__counter-field">
                      <div class="cart-counter">
                        <button
                          @click="deleteCountFromCart(item)"
                          class="cart-counter__action cart-counter__action--minus"
                          type="button">
                          <i
                            class="fa fa-minus"></i>
                        </button>
                        <div class="cart-counter__field">
                          <input
                            v-model="item.quantity"
                            type="text" class="cart-counter__input" />
                        </div>
                        <button
                          @click="addCountToCart(item)"
                          class="cart-counter__action cart-counter__action--plus"
                          type="button">
                          <i
                            class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <div class="cart-actions__delete">
                      <button
                        @click="removeFromCart(item)"
                        class="cart-item-delete-btn">
                        <i class="fa fa-trash cart-item-delete-btn__icon"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cart-page__aside">
      <div class="summary-cart-info">
        <div class="summary-cart-info__checkout">
          <div class="summary-cart-info__actions">
            <a href="/cart/checkout/" class="btn btn-primary summary-cart-info__checkout-btn">Перейти к оформлению</a>
          </div>
          <div class="summary-cart-info__checkout-msg">Вы можете оформить заказ как физическое или юридическое лицо.
            Выбрать способ оплаты и настроить удобную доставку.</div>
        </div>

        <div class="summary-cart-info__part summary-cart-info__part--products">
          <div class="summary-cart-info__block-title">Корзина</div>
          <div class="summary-cart-info__part-content">
            <div class="summary-products">
              <div class="summary-products__row">
                <div class="summary-products__label">Товары ({{ $cart.counts }})</div>
                <div class="summary-products__price">{{ formatNumberWithSpaces($cart.raw_summary) }} руб.</div>
              </div>

              <div
                v-if="$cart.profit_cart"
                class="summary-products__row">
                <div class="summary-products__label">Скидка</div>
                <div class="summary-products__price summary-products__price--sale">-{{ formatNumberWithSpaces($cart.profit_cart) }} руб.</div>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-cart-info__part summary-cart-info__part--summary-payment">
          <div class="summary-cart-info__row summary-cart-price">
            <div class="summary-cart-price__label">К оплате</div>
            <div class="summary-cart-price__value">{{formatNumberWithSpaces($cart.summary)}} руб.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { settings } from '../../variables'
import CartMixin from './mixins/CartMixin.vue'
import UtilsMixin from '../../vue_mixins/UtilsMixin.vue'


export default {

  name: 'CartPage',
  mixins: [CartMixin, UtilsMixin],

  components: {

  },

  data() {
    return {
      baseUrl: settings.apiBaseUrl
    }
  },

  mounted() {
    
  },

  methods: {

  },

}
</script>


<style lang="scss"></style>
